__turbopack_context__.v({
  "actions": "HNigNa_actions",
  "avatar": "HNigNa_avatar",
  "bookmarkPlaceholder": "HNigNa_bookmarkPlaceholder",
  "commentPlaceholder": "HNigNa_commentPlaceholder",
  "container": "HNigNa_container",
  "footerText": "HNigNa_footerText",
  "header": "HNigNa_header",
  "headerContent": "HNigNa_headerContent",
  "instagramMedia": "HNigNa_instagramMedia",
  "likePlaceholder": "HNigNa_likePlaceholder",
  "line100": "HNigNa_line100",
  "line144": "HNigNa_line144",
  "line224": "HNigNa_line224",
  "line60": "HNigNa_line60",
  "logoContainer": "HNigNa_logoContainer",
  "mainLink": "HNigNa_mainLink",
  "sharedPost": "HNigNa_sharedPost",
  "spacerLarge": "HNigNa_spacerLarge",
  "spacerMedium": "HNigNa_spacerMedium",
  "subtitle": "HNigNa_subtitle",
  "title": "HNigNa_title",
  "titleSection": "HNigNa_titleSection",
  "viewPost": "HNigNa_viewPost",
});
